// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

// ProtectedRoute component to check token existence
const ProtectedRoute = ({ children }) => {
    // Check if the token exists in localStorage
    const api = JSON.parse(localStorage.getItem('api'));

    // If token doesn't exist, redirect to the login page
    if (!api) {
        return <Navigate to="/login" />;
    }

    // Render the protected component if the token exists
    return children;
};

export default ProtectedRoute;
